var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowserArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89577 1.14781C9.16137 1.42873 9.14895 1.87177 8.86802 2.13737L2.63458 8.03075L8.86535 13.8601C9.14766 14.1242 9.16241 14.5672 8.89829 14.8495C8.63417 15.1318 8.1912 15.1465 7.90889 14.8824L1.13461 8.54459C0.9936 8.41267 0.91335 8.22835 0.912844 8.03526C0.912338 7.84216 0.991621 7.65743 1.13194 7.52477L7.90621 1.12006C8.18714 0.854461 8.63018 0.866885 8.89577 1.14781Z",
    fill: "#7D7D7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserArrowLeft);
export default __webpack_public_path__ + "static/media/browserArrowLeft.30bf2af4e8515352ab713cab59ff6cd2.svg";
export { ForwardRef as ReactComponent };